import dayjs from 'dayjs';


/**
 * Is the specified date in the future?
 * 
 * @param {Date} date 
 */
export default function isDateInFuture(date) {
    const today = dayjs().startOf('day');
    const parsedDate = dayjs(date).startOf('day');

    return parsedDate.isAfter(today);
}
